import { useState } from "react";
import { Card } from "react-bootstrap";
import BaseService from "../../../services/BaseService";
import { FormInput } from "../../formElements/FormInput";
import CommonService from "../../../services/CommonService";
import { useContext } from "react";
import { UserContext } from "../../../UserContext";
import { AlertType } from "../../../utils";
import SecurityContainer from '../securityContainer';

const UpdateAuthorizationCode = () => {
    const user = useContext(UserContext);
    const [formErrors, setFormErrors] = useState(false);
    const [authorizationInput, setAuthorizationInput] = useState('');
    
    const handleSubmit = (e) => {
      e.preventDefault();
        const form = e.target.closest('admin-Authorization');   
        let invalidCode = authorizationInput === '' ? true : false;
        setFormErrors(invalidCode);
          if (!invalidCode){  
            var obj = {
              msgId: null,
              sysId: null,
              opr: "updateAdminAuthorizationCode",
              hdrStruct: null,
              queryParam: null,
              reqData: {
                "adminAuthorizationConfig" : {
                  'authorizationCode' : authorizationInput, 
                  "lastUpdateUser": CommonService.getUserName(user)
                }
              },
            };
        
            BaseService.processRequest(obj)
              .then((res) => res)
              .then((result) => {
                if (result.data.errors && result.data.errors.length > 0){
                  CommonService.displayServerMessage(result.data.errors[0].message, AlertType.Error);
                  }
                  else{
                    CommonService.displayServerMessage("Admin Authorization Code Updated Successfully!", AlertType.Success);
                  }
              });
          }
    }
    
  return (
    <SecurityContainer>
      <form onSubmit={(e) => e.preventDefault()} id="admin-Authorization">
        <Card>
          <div className="panel panel-default">
            <div className="panel-heading">
              <div className="container">
                <div id="packet_id" className="panel-title" >
                  <h1 className="menu-title">Admin Password Update</h1>
                </div>
              </div>
            </div>
            <div className="panel-body">
              <div className="container">
                <div className="form">
                  <div className="d-flex justify-content-between">

                    <div className="control">
                      <FormInput label="New Admin UI Authorization Code"
                        name="authorizationInput"
                        type="text"
                        maxLength={50}
                        isrequired={true}
                        validations={["required"]}
                        value={authorizationInput}
                        onChange={e => setAuthorizationInput(e.target.value)}
                      />
                       {formErrors && <p className="error">Invalid Password</p>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="panel-footer">
              <div className="fleft">
                <a href="/admin" className="dk-blue-color link-button">Back to Admin</a>
              </div>

              <div style={{ overflow: 'auto' }}>
                <button className="custom-button fright" onClick={(e) => handleSubmit(e)}>Update</button>
              </div>
            </div>
          </div>

        </Card>

      </form>
    </SecurityContainer>
  )
   
}

export default UpdateAuthorizationCode;